import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export default function LoadingSkeleton({height, count}:{height:number, count?: number}){
  return <Skeleton height={height} count={count} />
}
